module.exports = __webpack_public_path__ + "img/linkedin.d11a9c0b.png";